import React from "react";
import AppHead from "@/Components/AppHead";

const Guest = ({ title, children }) => {
    return (
        <div className="h-full">
            <AppHead title={title} />
            {children}
        </div>
    );
};

export default Guest;
